/**
 * As the Gravity Forms User Registration form doesn't allow to remove the confirm password field then
 * this function copies the password to that field.
 */
export function registrationConfirmation() {
	const $registerForm = $( document ).find( '.modal-registration' );
	if ( !$registerForm.length ) {
		return;
	}

	const formId = $registerForm.find( '.modal-registration-content' ).data( 'form-id' );
	const $title = $registerForm.find( '.modal-registration-title' );
	const $subtitle = $registerForm.find( '.modal-registration-subtitle' );
	const $footer = $registerForm.find( '.modal-footer' );
	const $container = $registerForm.find( '.o__modal-container' );

	$( document ).bind( 'gform_post_render', function onFormEvent( event, actualFormId ) {
		if ( actualFormId === formId ) {
			setTimeout( function hideHeader() {
				if ( !$( document ).find( '.modal-registration' ).find( '.gform_body' ).length ) {
					$title.remove();
					$subtitle.remove();
					$footer.remove();
					$container.css( 'width', 'auto' );
				}
			}, 500 );
		}
	});
}
